import { Container, NoticeBox } from "./styles";

const BloqueioCadastroNotice = () => (
  <Container id="bloqueioCadastroNotice">
    <NoticeBox>
      <p>Prezado cliente,</p>
      <p>Constam em nosso sistema algumas divergências em seu cadastro.</p>
      <p>Para maiores informações entre em contato com seu representante.</p>
      <p>
        Neste momento, você poderá fechar o seu pedido somente pela opção de
        pagamento <strong>Cartão de Crédito</strong>.
      </p>
    </NoticeBox>
  </Container>
);

export default BloqueioCadastroNotice;
